import { useEffect } from "react";

export default function Locations() {
  useEffect(() => {
    window.StoreRocket.init({
      selector: ".storerocket-store-locator",
      account: "BkJ1QZKJqR",
    });
  }, []);

  return (
    <div className="card mx-auto w-full max-w-lg px-4 py-8 text-center">
      <h1 className="text-red mb-4 font-bold">{"Locations"}</h1>
      <div className="storerocket-store-locator pt-4"></div>
    </div>
  );
}
